const BaseUrl = "http://localhost:8000";
// const BaseUrl = 'https://wizzgeeks.com/'

export const USER_INFO_EMAIL = `${BaseUrl}/send-email`;
export const GET_ALL_BLOGS = `${BaseUrl}/get-blog`;
export const SINGLE_BLOG_GET = `${BaseUrl}/get-single-blog`;
